/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  Input,
  Output,
  AfterViewInit,
  EventEmitter,
} from "@angular/core";
import {
  getQueryParam,
  setActualDimensions,
} from "../../liveshop/utils/helpers";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LiveshopService } from "src/app/services/liveshop/liveshop.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ApiContactService } from "src/app/services/contacts/api-contact.service";
import { ChangePasswordComponent } from "../../auth-feature/change-password/change-password.component";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { StoresService } from "src/app/services/catalog/stores.service";
import { retryExpiry } from "./../../../../environments/config";
import { PromolinkAuthorizationService } from "src/app/services/orderlinks/promolink-authorization.service";
@Component({
  selector: "app-order-summary",
  templateUrl: "./order-summary.component.html",
  styleUrls: ["./order-summary.component.scss"],
})
export class OrderSummaryComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() summaryData;
  @Output() stripeRetry = new EventEmitter();
  windowWidth: any;
  logoSource = "assets/icons/Shopconnect_logo_new.png";
  shopconnectLogo = "assets/icons/Logo-US Spelling.png";
  orderPlacedLogo = "assets/icons/Orderplacedcart.png";
  orderFailedLogo = "assets/icons/orderFailed.svg";
  userDetails;
  orderId;
  ARDialog: boolean;
  paymentOrderId;
  footerEnabled = false;
  headerEnabled = false;
  userObject;
  isSubscriber = false;
  subscriberUpdated = false;
  isAppointment = true;
  isCheckoutEnabled = true;
  cartLength = 0;
  status;
  orderIcon;
  statusHeader;
  statusSubheader;
  statusDescription;

  constructor(
    public dialogRef: MatDialogRef<OrderSummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public localStorageService: LocalStorageService,
    private liveshopService: LiveshopService,
    public toastrService: ToastrService,
    public slotService: SlotService,
    public apiContactService: ApiContactService,
    private router: Router,
    public dialogService: DialogService,
    public storesService: StoresService,
    public promoLinkAuthorizationService: PromolinkAuthorizationService
  ) {}

  ngOnInit(): void {
    if (this.summaryData) {
      this.dialogData = this.summaryData;
    }
    this.status = this.dialogData?.data?.status;
    this.setStatusData();
    this.cartLength = this.dialogData?.data?.cartItems?.length
      ? this.dialogData.data.cartItems.length
      : 0;
    const config = JSON.parse(
      localStorage.getItem("companyConfig")
        ? localStorage.getItem("companyConfig")
        : localStorage.getItem("config")
    );
    if (config) {
      if (config.whiteshop.companyLogo && config.whiteshop.companyLogo.length) {
        this.logoSource = config.whiteshop.companyLogo;
      }
      if (config.whiteshop) {
        this.isAppointment = config.whiteshop.isScheduledAppointmentsEnabled;
        this.isCheckoutEnabled = config.whiteshop.isCheckoutProcessEnabled;
      }
    }
    if (getQueryParam("ARDialog", this.router)) {
      this.ARDialog = true;
    }
    // this.footerEnabled = config?.whiteshop?.isFooterEnabled;
    // this.headerEnabled = config?.whiteshop?.isHeaderEnabled;
    this.userDetails = this.dialogData.userDetails
      ? this.dialogData.userDetails
      : localStorage.getItem("user")
      ? { name: JSON.parse(localStorage.getItem("user")).displayName }
      : null;
    this.orderId = localStorage.getItem("currentOrderId");
    if (localStorage.getItem("consumerData")) {
      let consumer = JSON.parse(localStorage.getItem("consumerData"));
      this.isSubscriber = consumer.subscriber;
    }
    this.paymentOrderId = localStorage.getItem("currentOrder");
    this.userObject = JSON.parse(localStorage.getItem("user"));
    this.setDimensions();
  }

  ngAfterViewInit() {
    window.addEventListener("resize", () => {
      this.setDimensions();
    });
    const primaryThemeColor = localStorage.getItem("primaryThemeColor");
    primaryThemeColor &&
      document.documentElement.style.setProperty(
        "--primary-color",
        primaryThemeColor
      );
    const primaryFont = localStorage.getItem("primaryFont");
    primaryFont &&
      document.documentElement.style.setProperty("--primary-font", primaryFont);
    primaryFont &&
      document.documentElement.style.setProperty(
        "--pdp-primary-font",
        primaryFont
      );
  }
  setStatusData() {
    this.orderIcon =
      this.status === "Success" || this.dialogData?.payment === "cod"
        ? this.orderPlacedLogo
        : this.orderFailedLogo;
    this.statusHeader =
      this.status === "Success" || this.dialogData?.payment === "cod"
        ? "Order placed !"
        : this.status === "Processing"
        ? "Payment is Processing !"
        : "Payment failed !";
    this.statusSubheader =
      this.status === "Success" || this.dialogData?.payment === "cod"
        ? "Your order placed successfully."
        : this.status === "Processing"
        ? "Don't worry your money is safe ! If money is debited from your account and payment is not getting processed successfully, in that case you will be refunded automatically in 5-7 working days."
        : 'Your order is pending, you can view it in "My Orders".';
    this.statusDescription =
      this.status === "Success" || this.dialogData?.payment === "cod"
        ? "The order details will be shared via SMS/e-mail to you."
        : this.status === "Processing"
        ? ""
        : "Kindly finish your payment within next " +
          retryExpiry +
          " minutes to place the order";
  }

  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowWidth = dimensions.windowWidth;
  }

  isMobileDevice() {
    return this.windowWidth <= 6;
  }

  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 12;
  }

  isRetailer() {
    return localStorage.getItem("retailerToken");
  }

  loggedIn() {
    return localStorage.getItem("user");
  }

  redirectNavHeaders(type) {
    let url = window.location.origin;
    switch (type) {
      case "bookings":
        url += "/appointments";
        break;
      case "orders":
        url += "/myorders";
        break;
      case "address":
        url += "/myaddresses";
        break;
    }
    window.open(url, "_blank");
  }

  getCompanyLiveUrl() {
    let config = localStorage.getItem("config")
      ? JSON.parse(localStorage.getItem("config"))
      : JSON.parse(localStorage.getItem("companyConfig"));
    if (config && config.whiteshop && config.whiteshop.clickToCall) {
      return config.whiteshop.clickToCall.originUrl;
    } else {
      return "/";
    }
  }

  goToWidget() {
    window.location.assign(this.getCompanyLiveUrl());
  }

  close(type?) {
    if (this.summaryData) {
      this.goToWidget();
    } else if (this.dialogData.payment === "stripe") {
      if (this.status === "Fail" && type) {
        this.stripeRetry.emit({
          isRetryPayment: true,
          isMobile: this.isMobileDevice(),
        });
        // this.dialogRef.close({
        //   isRetryPayment: true,
        //   isMobile: this.isMobileDevice(),
        // });
      } else {
        window.close();
        setTimeout(() => {
          window.location.replace(window.location.href);
        }, 1000);
      }
    } else {
      this.dialogRef.close({
        isRetryPayment: this.status === "Fail" && type,
        isMobile: this.isMobileDevice(),
      });
      if (localStorage.getItem("currentOrder")) {
        localStorage.removeItem("currentOrder");
        this.router.navigateByUrl("/myorders");
      }
    }
  }

  openMyOrders() {
    // if (this.orderId) {
    // localStorage.setItem("openDetailedOrderView", this.orderId);
    window.open(location.origin + "/myorders");
    // }
  }
  openOrders() {
    if (!this.summaryData) {
      this.dialogRef.close();
    }
    localStorage.removeItem("currentOrder");
    this.router.navigateByUrl("/myorders");
  }
  subscribeNow() {
    let data = {};
    const companyCode = JSON.parse(
      sessionStorage.getItem("currentBusinessUnit")
    )?.company?.code;
    data["companyCode"] = companyCode;
    data["user"] = {};
    if (this.userObject.email) {
      data["user"]["email"] = this.userObject.email;
    }
    if (this.userObject.mobile) {
      data["user"]["mobile"] = this.userObject.mobile;
    }
    this.apiContactService.updateConsumerData(data).subscribe((res) => {
      if (res.subscriber) {
        this.subscriberUpdated = true;
        if (localStorage.getItem("consumerData")) {
          let consumer = JSON.parse(localStorage.getItem("consumerData"));
          consumer["subscriber"] = true;
          localStorage.setItem("consumerData", JSON.stringify(consumer));
        }
        this.toastrService.info("You have subscribed to our newsletter", null, {
          timeOut: 2000,
          positionClass: "toast-top-right",
        });
      }
    });
  }
  ngOnDestroy() {
    if (localStorage.getItem("openDetailedOrderView")) {
      localStorage.removeItem("openDetailedOrderView");
    }
    if (localStorage.getItem("primaryThemeColor")) {
      localStorage.removeItem("primaryThemeColor");
    }
    this.liveshopService.isOrderSummaryOpen.next("closed");
    document
      .getElementById("ws-body")
      .classList.remove("cdk-global-scrollblock");
  }

  menuActions(action) {
    if (this.slotService.websitePromolinkCB) {
      this.liveshopService.onMenuActions.next(
        action === "wishlist"
          ? action
          : action === "myorders"
          ? "myOrders"
          : action === "appointments"
          ? "myBookings"
          : "myAddresses"
      );
      this.dialogRef.close();
    } else {
      window.open(location.origin + "/" + action, null, "noreferrer");
    }
  }

  changePassword() {
    const matDialogRef = this.dialogService.openMatDialog(
      ChangePasswordComponent,
      null,
      true
    );
    matDialogRef.afterClosed().subscribe((data) => {
      console.log(data);
    });
  }

  logOut() {
    setTimeout(() => {
      const currentBusinessUnit = sessionStorage.getItem("currentBusinessUnit");
      this.localStorageService.resetUserData();
      sessionStorage.setItem("currentBusinessUnit", currentBusinessUnit);
      this.dialogRef?.close();
      this.toastrService.success("Logout successful", null, { timeOut: 2000 });
      this.liveshopService.currentUser = undefined;
      this.redirectUser();
    }, 1000);
  }

  redirectUser() {
    window.location.replace(
      window.location.href.replace("stores/promolink", "promolink")
    );
  }

  shareLink() {
    this.liveshopService.shareLink.next(true);
  }

  openCart() {
    this.liveshopService.openCart.next(true);
    this.dialogRef.close();
  }

  onPreviewClick(i) {
    this.liveshopService.onPreviewClick.next(i);
    this.dialogRef.close();
  }

  returnToLandingPage() {
    this.liveshopService.onReturnToLandingPage.next(true);
    this.dialogRef.close();
  }
}
